<template>
    <div>
      <v-card>
        <v-card-title><span class="pink--text">Religious Background</span>
          <v-spacer></v-spacer> <v-icon class="red--text" @click="$emit('closeInfo')">mdi-close</v-icon></v-card-title>
        <v-form @submit.prevent="submitForm" class="pa-2">
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.religions" multiple :items="LookupArr(dropDownList?.religionList)"
              item-text="text" item-value="value" label="Religion"></v-autocomplete>
            </v-col>   <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.community" multiple :items="LookupArr(dropDownList?.communityLst)"
              item-text="text" item-value="value" label="Community"></v-autocomplete>
            </v-col>   <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.caste" multiple :items="LookupArr(dropDownList?.casteList)"
              item-text="text" item-value="value" label="Caste"></v-autocomplete>
            </v-col>  
            <v-col cols="12" md="12" class="d-flex justify-end">
            <v-btn type="submit" class="primary elevation-0"> Submit</v-btn>
          </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        Indicator:"religious",
      };
    },
    props: {
      partnerpreference: {}, partnerpreferenceList: [],  dropDownList:{}
    },
    methods:{
  submitForm() {


this.$emit("religious", this.Indicator)
// Handle form submission logic here, e.g., send data to an API or update the state
},
}
  };
  </script>
  